import React, { Component } from "react";

import {
  CSpinner,
  CCard,
  CCardBody,
  CCardFooter,
  CCardHeader,
  CButton,
  CCollapse,
  CModal,
  CModalHeader,
  CModalBody,
  CModalFooter,
  CRow,
  CCol,
  CInputGroup,
  CInputGroupPrepend,
  CInput,
  CInputGroupText,
  CSelect,
  CSwitch,
  CPagination
} from "@coreui/react";
import ReactDOM from "react-dom";
import {
  RiArrowDownSLine,
  RiArrowUpSLine,
  RiCheckDoubleFill
} from "react-icons/ri";
import { connect } from "react-redux";
import { toastr } from "react-redux-toastr";
import {
  FormGroup,
  Input,
  InputGroup,
  InputGroupAddon,
  InputGroupText,
  Col,
  Label,
  Row
} from "reactstrap";
import { bindActionCreators } from "redux";

import { logout } from "../../../../actions/baseActions";
import { setObj } from "../../../../actions/noteActions";
import Breadcrumb from "../../../../components/Breadcrumb";
import Loading from "../../../../components/Loading";
import ProtectedRoute from "../../../../components/ProtectedRoute";
import URL from "../../../../config/api";
import axios from "../../../../config/axios";
import { groupAllocations } from "../../../../utils/allocation";
import "./style.css";

const FileDownload = require("js-file-download");

const appRoot = document.getElementById("root");

let currYear = new Date().getFullYear();

class TrailAllocate extends Component {
  constructor(props) {
    super(props);
    this.state = {
      list: [],
      // allocate: [],
      // user: [],
      hierarchy: [],
      trail_id: this.props.match.params.id,
      loading: true,
      listLoading: true,
      allocating: false,
      deleting: false,
      show: null,
      delete_id: null,
      group_id: null,
      region_id: null,
      school_id: null,
      class: "null",
      mine: false,
      classroomsListPage: 1,
      classroomsListLastPage: 1,
      yearRangeSelected: new Date().getFullYear(),
      yearsList: []
    };

    this.error = this.error.bind(this);
  }

  error(response) {
    if (response === "Unauthorized") {
      this.props.logout(this.props.user.token);
    } else {
      toastr.error("Falha", response);
    }
  }

  getDateList() {
    const currentYear = new Date().getFullYear();

    if (currentYear > 2022)
      this.setState({
        yearsList: Array.from(
          { length: currentYear + 1 - 2022 },
          (_, i) => i + 2022
        )
      });
  }

  componentDidMount() {
    this.props.setObj(16, this.props.currentRoute, this.props.currentRoute);
    this.getRoomsInfo();
    this.getDateList();
  }

  getDate(year) {
    const start = new Date(Date.UTC(year, 0, 1, 0, 0, 0));
    const end = new Date(Date.UTC(year, 11, 31, 23, 59, 59));
    const startString = start.toISOString().replace("Z", "");
    const endString = end.toISOString().replace("Z", "");

    return {
      start: startString,
      end: endString
    };
  }

  getRoomsInfo = page => {
    this.setState({ listLoading: true });
    let requestRoute = `${URL.api}community/room/listAllocation?page=${
      page || 1
    }&page_size=10`;

    axios
      .all([
        axios.get(requestRoute, {
          params: {
            group_id: this.props.general.active_roles.group_id,
            region_id: this.props.general.active_roles.region_id,
            school_id: this.props.general.active_roles.school_id,
            role_id: this.props.general.active_roles.role_id,
            user_id: this.props.user.user.id,
            with_users: false,
            start: this.getDate(this.state.yearRangeSelected).start,
            end: this.getDate(this.state.yearRangeSelected).end
          },
          headers: { Authorization: `Bearer ${this.props.user.token}` }
        }),
        axios.get(`${URL.api}activity/trail_allocation/list`, {
          params: { trail_id: this.props.match.params.id },
          headers: { Authorization: `Bearer ${this.props.user.token}` }
        }),
        axios.get(
          `${URL.api}activity/trail/singleView/${this.state.trail_id}`,
          { headers: { Authorization: `Bearer ${this.props.user.token}` } }
        )
      ])
      .then(
        axios.spread(
          (resp, respAllocate, respTrail) => {
            let list = [];
            let allocation = respAllocate.data.data;
            for (let i = 0; i < resp.data.data.length; i++) {
              let obj = {
                allocation_id: 0,
                room_id: resp.data.data[i].id,
                room_name: resp.data.data[i].name,
                room_id_external: resp.data.data[i].external_id,
                room_school_id: resp.data.data[i].school_id,
                room_school_name: resp.data.data[i].school_name,
                room_region_id: resp.data.data[i].region_id,
                room_region_name: resp.data.data[i].region_name,
                room_group_id: resp.data.data[i].group_id,
                room_group_name: resp.data.data[i].group_name,
                release: false,
                start_allocation: "",
                end_allocation: "",
                show: false,
                class: resp.data.data[i].class,
                room_start: resp.data.data[i].start
              };

              for (let j = 0; j < allocation.length; j++) {
                if (allocation[j].room_id === obj.room_id) {
                  obj.allocation_id = allocation[j].id;
                }
              }

              list.push(obj);
            }

            const hierarchy = groupAllocations(resp.data.data);
            this.setState({
              list,
              // allocation,
              hierarchy,
              trail: respTrail.data.data,
              listLoading: false,
              loading: false,
              group_id: resp.data.data.length
                ? resp.data.data[0].group_id
                : null,
              region_id: resp.data.data.length
                ? resp.data.data[0].region_id
                : null,
              school_id: resp.data.data.length
                ? resp.data.data[0].school_id
                : null,
              // classrooms: resp.data.data,
              classroomsListPage: resp.data.meta.current_page,
              classroomsListLastPage: resp.data.meta.last_page
            });
          },
          error => {
            this.error("Não foi possível obter as informações da alocação");
          }
        )
      );
  };

  onChangeAction = event => {
    let field = event.target.name.split("_")[0];
    let roomId = parseInt(event.target.name.split("_")[1]);
    let list = [];
    this.state.list.forEach(item => {
      list.push(item);
    });

    for (let i = 0; i < list.length; i++) {
      if (roomId === list[i].room_id) {
        if (field === "start") {
          list[i].start_allocation = event.target.value;
        } else if (field === "end") {
          list[i].end_allocation = event.target.value;
        }
      }
    }

    this.setState({
      list
    });
  };

  onChangeCheckBoxRelease = event => {
    let roomId = parseInt(event.target.id);
    let list = [];

    this.state.list.forEach(item => {
      list.push(item);
    });

    for (let i = 0; i < list.length; i++) {
      if (roomId === list[i].room_id) {
        list[i].release = !list[i].release;
      }
    }

    this.setState({ list });
  };

  allocateAction = roomId => {
    this.setState({ allocating: roomId });

    const room = this.state.list.find(room => room.room_id === roomId);

    const obj = {
      trail_id: this.state.trail_id,
      room_id: roomId
    };

    axios
      .post(
        `${URL.api}activity/trail_allocation/${
          room.allocation_id ? `update/${room.allocation_id}` : "insert"
        }`,
        obj,
        {
          headers: { Authorization: `Bearer ${this.props.user.token}` }
        }
      )
      .then(
        resp => {
          if (resp.data.success) {
            this.setState(state => ({
              list: state.list.map(room =>
                room.room_id === roomId
                  ? {
                      ...room,
                      allocation_id: room.allocation_id || resp.data.data
                    }
                  : room
              ),
              allocating: false
            }));

            toastr.success(
              "Alocada com sucesso!",
              "A trilha foi alocada na turma"
            );
          } else {
            toastr.error("Falha", "Não foi possível alocar a trilha");
            this.setState({
              allocating: false
            });
          }
        },
        () => {
          toastr.error("Falha", "Não foi possível alocar a trilha");
          this.setState({
            allocating: false
          });
        }
      );
  };

  deleteAction = allocationId => {
    this.setState({ deleting: true });

    axios
      .post(
        `${URL.api}activity/trail_allocation/delete/${allocationId}`,
        {},
        {
          headers: { Authorization: `Bearer ${this.props.user.token}` }
        }
      )
      .then(
        resp => {
          this.setState(state => ({
            list: state.list.map(room =>
              room.allocation_id === allocationId
                ? { ...room, allocation_id: 0 }
                : room
            ),
            deleting: false,
            showDeleteModal: false
          }));

          toastr.success("Apagada com sucesso!", "A alocação foi apagada");
        },
        error => {
          this.setState(state => ({
            deleting: false,
            showDeleteModal: false
          }));

          toastr.error("Falha", "Não foi possível apagar a alocação");
        }
      );
  };

  render() {
    const list = this.state.list?.filter(
      item =>
        (!this.state.group_id || item.room_group_id === this.state.group_id) &&
        (!this.state.region_id ||
          item.room_region_id === this.state.region_id) &&
        (!this.state.school_id ||
          item.room_school_id === this.state.school_id) &&
        (this.state.class === "null" ||
          item.class === (this.state.class === "true")) &&
        (!this.state.mine || !!item.mine)
    );

    let isAlagoas =
      this.props.general.active_roles.group_id === 49 ||
      this.props.general.active_roles.group_id === 86;

    const classrooms = this.state.list.filter(item => item.class);

    return (
      <React.Fragment>
        <Breadcrumb
          current={this.props.currentRoute}
          items={
            isAlagoas
              ? [{ path: "/trail/bank", to: "/trail/bank" }]
              : [{ path: "/trail/list", to: "/trail/list" }]
          }
        />
        {this.state.loading ? (
          <Loading top="45" left="50" />
        ) : (
          <Row>
            <Col md="12">
              {["G", "U", "R", "E"].includes(
                this.props.general.active_roles.type
              ) && (
                <CCard>
                  <CCardBody className="d-flex flex-column justify-content-end">
                    <CRow className="flex-1">
                      <CCol>
                        <div className="w-100 text-ellipsis">
                          <Label className="d-block w-100 text-ellipsis">
                            Ano
                          </Label>
                        </div>
                        <InputGroup>
                          <InputGroupAddon addonType="prepend">
                            <InputGroupText>
                              <span htmlFor="yearRange">Ano</span>
                            </InputGroupText>
                          </InputGroupAddon>
                          <Input
                            name="yearRange"
                            type="select"
                            value={
                              this.state.yearRangeSelected
                                ? this.state.yearRangeSelected
                                : 0
                            }
                            onChange={e =>
                              this.setState(
                                {
                                  yearRangeSelected: e.target.value
                                },
                                () => this.getRoomsInfo()
                              )
                            }
                          >
                            <option key="0" value={0}>
                              Todos
                            </option>
                            {this.state.yearsList.map((year, idx) => (
                              <option key={idx + 1} value={year}>
                                {year}
                              </option>
                            ))}
                          </Input>
                        </InputGroup>
                      </CCol>
                      <CCol>
                        <div className="w-100 text-ellipsis">
                          <Label className="d-block w-100 text-ellipsis">
                            Grupo
                          </Label>
                        </div>
                        <CInputGroup>
                          <CInputGroupPrepend>
                            <CInputGroupText>
                              <i className="fa fa-wrench"></i>
                            </CInputGroupText>
                          </CInputGroupPrepend>
                          <CSelect
                            value={this.state.group_id}
                            placeholder="Grupo"
                            onChange={e =>
                              this.setState(
                                {
                                  group_id: parseInt(e.target.value),
                                  region_id: 0,
                                  school_id: 0
                                },
                                () => this.getRoomsInfo()
                              )
                            }
                            disabled={
                              !!this.props.general.active_roles.group_id
                            }
                          >
                            <option value="0">Todos</option>
                            {this.state.hierarchy.map(item => (
                              <option value={item.group_id}>
                                {item.group_name}
                              </option>
                            ))}
                          </CSelect>
                        </CInputGroup>
                      </CCol>
                      <CCol>
                        <div className="w-100 text-ellipsis">
                          <Label className="d-block w-100 text-ellipsis">
                            Regional
                          </Label>
                        </div>
                        <CInputGroup>
                          <CInputGroupPrepend>
                            <CInputGroupText>
                              <i className="fa fa-globe"></i>
                            </CInputGroupText>
                          </CInputGroupPrepend>
                          <CSelect
                            value={this.state.region_id}
                            placeholder="Regional"
                            onChange={e =>
                              this.setState(
                                {
                                  region_id: parseInt(e.target.value),
                                  school_id: 0
                                },
                                () => this.getRoomsInfo()
                              )
                            }
                            disabled={
                              !!this.props.general.active_roles.region_id
                            }
                          >
                            <option value="0">Todas</option>
                            {this.state.hierarchy
                              .find(
                                item => item.group_id === this.state.group_id
                              )
                              ?.regions.map(item => (
                                <option value={item.region_id}>
                                  {item.region_name}
                                </option>
                              ))}
                          </CSelect>
                        </CInputGroup>
                      </CCol>
                      <CCol>
                        <div className="w-100 text-ellipsis">
                          <Label className="d-block w-100 text-ellipsis">
                            Escola
                          </Label>
                        </div>
                        <CInputGroup>
                          <CInputGroupPrepend>
                            <CInputGroupText>
                              <i className="fa fa-institution"></i>
                            </CInputGroupText>
                          </CInputGroupPrepend>
                          <CSelect
                            value={this.state.school_id}
                            placeholder="Escola"
                            onChange={e =>
                              this.setState(
                                {
                                  school_id: parseInt(e.target.value)
                                },
                                () => this.getRoomsInfo()
                              )
                            }
                            disabled={
                              !!this.props.general.active_roles.school_id
                            }
                          >
                            <option value="0">Todas</option>
                            {this.state.hierarchy
                              .find(
                                item => item.group_id === this.state.group_id
                              )
                              ?.regions.find(
                                item => item.region_id === this.state.region_id
                              )
                              ?.schools.map(item => (
                                <option value={item.school_id}>
                                  {item.school_name}
                                </option>
                              ))}
                          </CSelect>
                        </CInputGroup>
                      </CCol>
                    </CRow>
                  </CCardBody>
                </CCard>
              )}

              <h3 className="mb-4">
                Aloque <strong>{this.state.trail?.name || "a trilha"}</strong>{" "}
                em uma turma
              </h3>
              {this.state.listLoading ? (
                <Loading top="45" left="50" />
              ) : (
                <>
                  {classrooms.length > 0 ? (
                    <>
                      {classrooms.map(classes => (
                        <CCard
                          accentColor="primary mt-0 mb-2"
                          key={classes.room_id}
                        >
                          <CCardHeader
                            className={
                              this.state.show === classes.room_id
                                ? "d-flex align-items-center"
                                : "d-flex align-items-center rounded border-0"
                            }
                          >
                            <h4 className="m-0 p-0 flex-1 d-flex align-items-center">
                              {classes.room_name}
                              {classes.room_id_external && (
                                <span className="text-muted ml-2 small">
                                  {" "}
                                  ({classes.room_id_external})
                                </span>
                              )}
                              {classes.allocation_id !== 0 && (
                                <RiCheckDoubleFill className="ml-2 text-success" />
                              )}
                            </h4>
                            <CButton
                              className="text-left m-0 p-0"
                              onClick={() =>
                                this.setState(state => ({
                                  show:
                                    state.show === classes.room_id
                                      ? null
                                      : classes.room_id
                                }))
                              }
                              style={{ boxShadow: "none" }}
                            >
                              <h4 className="m-0 p-0 d-flex align-items-center">
                                {!classes.allocation_id && (
                                  <CButton
                                    color="primary"
                                    className="d-flex justify-content-center align-items-center"
                                    disabled={
                                      this.state.allocating === classes.room_id
                                    }
                                    onClick={() =>
                                      this.allocateAction(classes.room_id)
                                    }
                                  >
                                    <>
                                      <span
                                        style={
                                          this.state.allocating ===
                                          classes.room_id
                                            ? { opacity: 0 }
                                            : null
                                        }
                                      >
                                        Alocar
                                      </span>

                                      {this.state.allocating ===
                                        classes.room_id && (
                                        <CSpinner
                                          size="sm"
                                          color="white"
                                          style={{ position: "absolute" }}
                                        />
                                      )}
                                    </>
                                  </CButton>
                                )}
                                {classes.allocation_id !== 0 && (
                                  <CButton
                                    color="danger"
                                    className="d-flex justify-content-center align-items-center ml-2"
                                    disabled={
                                      this.state.deleting === classes.room_id
                                    }
                                    onClick={() =>
                                      this.setState({
                                        delete_id: classes.allocation_id,
                                        showDeleteModal: true
                                      })
                                    }
                                  >
                                    <>
                                      <span
                                        style={
                                          this.state.deleting ===
                                          classes.room_id
                                            ? { opacity: 0 }
                                            : null
                                        }
                                      >
                                        Cancelar
                                      </span>
                                      {this.state.deleting ===
                                        classes.room_id && (
                                        <CSpinner
                                          size="sm"
                                          color="white"
                                          style={{ position: "absolute" }}
                                        />
                                      )}
                                    </>
                                  </CButton>
                                )}
                              </h4>
                            </CButton>
                          </CCardHeader>
                        </CCard>
                      ))}
                      <CPagination
                        align="end"
                        className="mt-1"
                        activePage={this.state.classroomsListPage}
                        pages={this.state.classroomsListLastPage}
                        onActivePageChange={page =>
                          this.setState({ classroomsListPage: page }, () => {
                            this.getRoomsInfo(page);
                          })
                        }
                      />
                    </>
                  ) : (
                    <div className="p-5 text-center text-muted w-100">
                      Nenhuma turma encontrada
                    </div>
                  )}
                </>
              )}
            </Col>
          </Row>
        )}
        <DeleteModal
          show={this.state.showDeleteModal}
          onClose={() => this.setState({ showDeleteModal: false })}
          onDelete={() => this.deleteAction(this.state.delete_id)}
        />
        <ProtectedRoute routeId={this.props.currentRoute} />
      </React.Fragment>
    );
  }
}

const mapStateToProps = state => ({
  user: state.user,
  general: state.general,
  profile: state.profile
});

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      logout,
      setObj
    },
    dispatch
  );
}
class DeleteModal extends Component {
  constructor(props) {
    super(props);
    this.el = document.createElement("div");
  }

  componentDidMount() {
    appRoot.appendChild(this.el);
  }

  componentWillUnmount() {
    appRoot.removeChild(this.el);
  }

  render() {
    return ReactDOM.createPortal(
      <CModal
        color="danger"
        show={this.props.show}
        centered
        onClose={() => this.props.onClose()}
        closeOnBackdrop={false}
      >
        <CModalHeader closeButton>Apagar alocação</CModalHeader>
        <CModalBody>Deseja apagar a alocação?</CModalBody>
        <CModalFooter>
          <CButton color="danger" onClick={() => this.props.onDelete()}>
            Confirmar
          </CButton>
          <CButton color="secondary" onClick={() => this.props.onClose()}>
            Cancelar
          </CButton>
        </CModalFooter>
      </CModal>,
      this.el
    );
  }
}
export default connect(mapStateToProps, mapDispatchToProps)(TrailAllocate);
